"use strict";

/**
* @author Jirachai Chansivanon <antronic.inc@gmail.com>
* @see {@link https://github.com/antronic/that-baht-text-js|GitHub}
*/ // options
var MAX_POSITION = 6;
var UNIT_POSITION = 0;
var TEN_POSITION = 1;
var PRIMARY_UNIT = "\u0E1A\u0E32\u0E17";
var SECONDARY_UNIT = "\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C";
var WHOLE_NUMBER_TEXT = "\u0E16\u0E49\u0E27\u0E19";
var NUMBER_TEXTS = "\u0E28\u0E39\u0E19\u0E22\u0E4C,\u0E2B\u0E19\u0E36\u0E48\u0E07,\u0E2A\u0E2D\u0E07,\u0E2A\u0E32\u0E21,\u0E2A\u0E35\u0E48,\u0E2B\u0E49\u0E32,\u0E2B\u0E01,\u0E40\u0E08\u0E47\u0E14,\u0E41\u0E1B\u0E14,\u0E40\u0E01\u0E49\u0E32,\u0E2A\u0E34\u0E1A".split(",");
var UNIT_TEXTS = "\u0E2A\u0E34\u0E1A,\u0E23\u0E49\u0E2D\u0E22,\u0E1E\u0E31\u0E19,\u0E2B\u0E21\u0E37\u0E48\u0E19,\u0E41\u0E2A\u0E19,\u0E25\u0E49\u0E32\u0E19".split(",");
var getIntegerDigits = function getIntegerDigits(numberInput) {
  return parseInt(numberInput.split(".")[0], 10).toString();
};
var getFractionalDigits = function getFractionalDigits(numberInput) {
  return parseInt(numberInput.split(".")[1], 10).toString();
};
var hasFractionalDigits = function hasFractionalDigits(numberInput) {
  return numberInput !== undefined && numberInput != "0";
};
var isZeroValue = function isZeroValue(number) {
  return number == 0;
};
var isUnitPosition = function isUnitPosition(position) {
  return position == UNIT_POSITION;
};
var isTenPosition = function isTenPosition(position) {
  return position % MAX_POSITION == TEN_POSITION;
};
var isMillionsPosition = function isMillionsPosition(position) {
  return position >= MAX_POSITION && position % MAX_POSITION == 0;
};
var isLastPosition = function isLastPosition(position, lengthOfDigits) {
  return position + 1 < lengthOfDigits;
};
var reverseNumber = function reverseNumber(number) {
  var numberStr = number.toString();
  return numberStr.split("").reverse().join("");
};
var getBathUnit = function getBathUnit(position, number) {
  var unitText = "";
  if (!isUnitPosition(position)) {
    unitText = UNIT_TEXTS[Math.abs(position - 1) % MAX_POSITION];
  }
  if (isZeroValue(number) && !isMillionsPosition(position)) {
    unitText = "";
  }
  return unitText;
};
var getBathText = function getBathText(position, number, lengthOfDigits) {
  var numberText = NUMBER_TEXTS[number];
  if (isZeroValue(number)) {
    return "";
  }
  if (isTenPosition(position) && number == 1) {
    numberText = "";
  }
  if (isTenPosition(position) && number == 2) {
    numberText = "\u0E22\u0E35\u0E48";
  }
  if (isMillionsPosition(position) && isLastPosition(position, lengthOfDigits) && number == 1) {
    numberText = "\u0E40\u0E2D\u0E47\u0E14";
  }
  if (lengthOfDigits == 2 && isLastPosition(position, lengthOfDigits) && number == 1) {
    numberText = "\u0E40\u0E2D\u0E47\u0E14";
  }
  if (lengthOfDigits > 1 && isUnitPosition(position) && number == 1) {
    numberText = "\u0E40\u0E2D\u0E47\u0E14";
  }
  return numberText;
}; // convert function without async
var convert = function convert(numberInput) {
  var numberReverse = reverseNumber(numberInput);
  var textOutput = ""; // console.log('>', numberReverse.split(''))
  numberReverse.split("").forEach(function (number, i) {
    textOutput = "".concat(getBathText(i, number, numberReverse.length)).concat(getBathUnit(i, number)).concat(textOutput);
  });
  return textOutput;
};
var parseFloatWithPrecision = function parseFloatWithPrecision(number) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var numberFloatStr = parseFloat(number).toString().split(".");
  var integerUnitStr = numberFloatStr[0];
  var fractionalUnitStr = numberFloatStr.length == 2 ? numberFloatStr[1].substring(0, precision) : "00";
  return parseFloat("".concat(integerUnitStr, ".").concat(fractionalUnitStr)).toFixed(precision);
};
var convertFullMoney = function convertFullMoney(numberInput) {
  var numberStr = parseFloatWithPrecision(numberInput);
  var integerDigits = getIntegerDigits(numberStr);
  var fractionalDigits = getFractionalDigits(numberStr);
  var intTextOutput = convert(integerDigits);
  var textOutput = [];
  if (intTextOutput) {
    textOutput.push("".concat([intTextOutput, PRIMARY_UNIT].join("")));
  }
  if (intTextOutput && !hasFractionalDigits(fractionalDigits)) {
    textOutput.push(WHOLE_NUMBER_TEXT);
  }
  if (hasFractionalDigits(fractionalDigits) && convert(fractionalDigits)) {
    textOutput.push("".concat([convert(fractionalDigits), SECONDARY_UNIT].join("")));
  }
  return textOutput.join("");
};
if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
  module.exports = convertFullMoney;
  exports["default"] = convertFullMoney;
  exports.THBText = convertFullMoney;
} else {
  window.THBText = convertFullMoney;
}